"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _emotion = require("../../utils/emotion");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _Text = _interopRequireDefault(require("../Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var getStringifiedValue = function getStringifiedValue(v) {
  if (['string', 'number', 'boolean', 'undefined'].includes(_typeof(v))) {
    return String(v);
  }
  if (v === null) {
    return 'null';
  }
  return JSON.stringify(v);
};
var FieldComponent = function FieldComponent(props) {
  var legend = props.legend,
    value = props.value,
    onChange = props.onChange,
    options = props.options,
    defaultValue = props["default"];
  var def = (0, _react.useMemo)(function () {
    return getStringifiedValue(defaultValue);
  }, [defaultValue]);
  var currentValue = (0, _react.useMemo)(function () {
    return getStringifiedValue(value);
  }, [value]);
  var rootClass = (0, _useCss["default"])(function (theme) {
    return _objectSpread({
      display: 'inline-flex',
      flexDirection: 'column',
      padding: theme.size(1, 4, 1, 1),
      margin: 0,
      marginRight: theme.size(1),
      marginBottom: theme.size(1),
      border: "1px solid ".concat(theme.palette.accent.secondary.color),
      borderRadius: theme.size(0.5),
      gap: theme.size(0.5),
      maxHeight: '351px',
      overflow: 'hidden',
      overflowY: 'auto'
    }, theme.scroll({
      color: 'secondary'
    }));
  });
  var legendClass = (0, _useCss["default"])(function (theme) {
    return {
      display: 'flex',
      color: theme.palette.accent.secondary.contrast.low,
      backgroundColor: theme.palette.accent.secondary.color,
      padding: theme.size(0.25, 1),
      borderRadius: theme.size(0.5)
    };
  });
  var labelClass = (0, _useCss["default"])(function (theme) {
    return {
      display: 'flex',
      alignItems: 'center',
      gap: theme.size(1),
      cursor: 'pointer'
    };
  });
  var radioClass = (0, _useCss["default"])(function (theme) {
    return {
      padding: 0,
      margin: 0,
      accentColor: theme.palette.accent.secondary.color,
      cursor: 'pointer',
      width: theme.size(2),
      height: theme.size(2),
      '&:focus-visible': {
        outlineOffset: 0,
        outlineColor: theme.palette.accent.secondary.color
      }
    };
  });
  var textClass = (0, _useCss["default"])(function () {
    return {
      whiteSpace: 'nowrap',
      maxWidth: 300
    };
  });
  var defaultRadioClass = (0, _useCss["default"])(function () {
    return {
      textDecoration: 'underline'
    };
  });
  var handleChange = (0, _react.useCallback)(function (v) {
    return function () {
      onChange(v);
    };
  }, [onChange]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("fieldset", {
    className: rootClass,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("legend", {
      className: legendClass,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text["default"], {
        variant: "code",
        size: "small",
        weight: "bold",
        children: legend
      })
    }), options.map(function (opt, index) {
      var v = getStringifiedValue(opt);
      var isDefault = def !== 'undefined' && def === v;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
        className: labelClass,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          value: v,
          type: "radio",
          name: legend,
          className: radioClass,
          checked: currentValue === v,
          onChange: handleChange(opt)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text["default"], {
          title: v,
          size: "small",
          variant: "code",
          className: (0, _emotion.cx)(textClass, isDefault && defaultRadioClass),
          children: v
        })]
      }, "".concat(v, "_").concat(index));
    })]
  });
};
var _default = FieldComponent;
exports["default"] = _default;